import { render } from "./SlotScroll.vue?vue&type=template&id=76b51693&scoped=true"
import script from "./SlotScroll.vue?vue&type=script&lang=js"
export * from "./SlotScroll.vue?vue&type=script&lang=js"

import "./SlotScroll.vue?vue&type=style&index=0&id=76b51693&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b51693"]])

export default __exports__